<script>
  export default {
    name: 'TheReviewSubmitButton',
    methods: {
      async releaseToAd() {
        try {
          await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}/status`,
            method: 'put',
            data: {
              new_status: 'Released to AD',
              project_id: this.reviewInfo.project_id
            }
          })
          this.formSubmitted = true
          this.$root.$bvToast.toast(
            `You have successfully updated the status of the review for ${this.reviewInfo.course}.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
        } catch (err) {
          this.$root.$bvToast.toast(
            `Error updating the status of the review for ${this.reviewinfo.course}. If the problem persists, please contact the OFDIT lead.\n${err.message}`,
            {
              title: 'Error',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            }
          )
        } finally {
          const response = await this.$store.dispatch('cr_callAPI', {
            url: `/r/reviews/${this.reviewInfo.id}`
          })
          response.user_token = this.reviewInfo.user_token
          await this.$store.commit('cr_updateReviewInfo', response)
        }
      }
    },
    computed: {
      reviewInfo() {
        return this.$store.getters.reviewInfo
      },
      showButton() {
        let result = false
        if (this.reviewInfo.reviewer_role === 'OFDIT lead') {
          if (
            this.reviewInfo.status === 'Reviews submitted' ||
            this.reviewInfo.status === 'Developer response' ||
            this.reviewInfo.status === 'Released to AD'
          ) {
            result = true
          }
        } else if (
          this.reviewInfo.reviewer_role === 'Developer' &&
          this.reviewInfo.status === 'Released to AD & dev'
        ) {
          result = true
        } else if (
          this.reviewInfo.reviewer_role === 'Academic director' &&
          this.reviewInfo.status === 'Released to AD'
        ) {
          result = true
        }
        return result
      },
      submitText() {
        let result = 'There is no action for you to commit at this time.'
        if (this.reviewInfo.reviewer_role === 'OFDIT lead') {
          if (this.reviewInfo.status === 'Reviews submitted') {
            result = 'Release to AD & developer'
          }
          if (this.reviewInfo.status === 'Developer response') {
            result = 'Close review'
          }
          if (this.reviewInfo.status === 'Released to AD') {
            result = 'Release to Developer'
          }
        } else if (
          this.reviewInfo.reviewer_role === 'Academic director' &&
          this.reviewInfo.status === 'Released to AD & dev'
        ) {
          result =
            'Once you have completed your review, please email the OFDIT lead. You may use the email listed at the top of this form.'
        } else if (
          this.reviewInfo.reviewer_role === 'Developer' &&
          this.reviewInfo.status === 'Released to AD & dev'
        ) {
          result = "I'm finished"
        } else if (
          this.reviewInfo.reviewer_role === 'Academic director' &&
          this.reviewInfo.status === 'Released to AD'
        ) {
          result = 'Release to Developer'
        }
        return result
      }
    }
  }
</script>

<template>
  <div>
    <b-button
      v-if="showButton"
      size="lg"
      type="submit"
      variant="primary"
      class="float-right"
      >{{ submitText }}</b-button
    >
    <b-button
      v-if="
        showButton &&
          reviewInfo.reviewer_role === 'OFDIT lead' &&
          reviewInfo.status === 'Reviews submitted'
      "
      size="lg"
      @click="releaseToAd"
      variant="primary"
      >Release to AD only</b-button
    >
    <b-alert :show="!showButton" variant="info" v-else>{{
      submitText
    }}</b-alert>
  </div>
</template>

<style scoped></style>
